export default __webpack_public_path__ + "static/media/Slide1.db07a504.jpeg";